import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SvgIcon } from '@k12/models';
import { SvgIconComponent } from '@k12/ui-primitives';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-user-record-widget',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressBarModule, SvgIconComponent],
  templateUrl: './user-record-widget.component.html',
  styleUrls: ['./user-record-widget.component.scss']
})
export class UserRecordWidgetComponent implements OnInit, OnChanges {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() userData: any[] = [];
  @Input() value: string;
  @Input() title: string;
  @Input() percentage: number;
  @Input() growth: number;
  @Input() svgName: SvgIcon;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnChanges(): void {}
}

